import React from 'react';
import {useRef, useState, useEffect} from 'react';
import {User, UserSelect, FetchActiveUsers} from './UserSelect'
import PhotoDisplay from './PhotoDisplay';
import './App.css'
import Cookies from 'js-cookie';
import { SelectInstance } from 'react-select';

function Clock() {
	interface Location {
		id: number;
		short_name: string;
		long_name: string;
	}
	
	interface Unit {
		id: number;
		unit: string;
		active: boolean;
	}

	interface Option {
		value: any;
		label: string;
	}

	var userRef = useRef<HTMLSelectElement>(null);
	var timeRef = useRef<HTMLInputElement>(null);
	var dateRef = useRef<HTMLInputElement>(null);
	var unitRef = useRef<HTMLSelectElement>(null);
	var locationRef = useRef<HTMLSelectElement>(null);
	var selectRef = useRef<SelectInstance<Option | null>>(null)

	const [isVisible, setIsVisible] = useState(false)
	const [users, setUsers] = useState<User[]>([])
	const [currentTime, setCurrentTime] = useState<string>("")
	const [selectedUser, setSelectedUser] = useState<User>({ id: 0, first_name: "", middle_name: "", last_name: "", signed_in: false, photo: "", active: false, email: "", password: "", role: "" })
	const [respMsg, setRespMsg] = useState("")
	const [units, setUnits] = useState<Unit[]>([{id:0, unit:"", active: false}])
	const [locations, setLocations] = useState<Location[]>([])
	const [selectedLocation, setSelectedLocation] = useState<Location>({id:0, short_name:"", long_name:""})
	const [selectedUnit, setSelectedUnit] = useState<Unit>({id:0, unit:"", active: false})

	var currentDate = new Date((new Date().setHours(new Date().getHours() - (new Date().getTimezoneOffset() / 60)))).toISOString()

	async function getUnitByID(id: number) {
		try {
			const response = await fetch(process.env.REACT_APP_API+"/api/unit?id="+id)
			const result = await response.json()
			if (result) {
				setUnits([result])
				setSelectedUnit(result)
			}
		}
		catch (e) {
			console.log(e)
		}
	}
	async function getUnitsForUser(id: number) {
		try {
			const response = await fetch(process.env.REACT_APP_API+"/api/unitsForUser?userID="+id)
			const result = await response.json()
			if (result) {
				setUnits(result)
				if (result.length === 1) {
					setSelectedUnit(result[0])
				}
			}
		}
		catch (e) {
			console.log(e)
		}
	}
	
	async function getLocationsForUser(id: number) {
		try {
			const response = await fetch(process.env.REACT_APP_API+"/api/locationsForUser?userID="+id)
			const result = await response.json()
			if (result) {
				setLocations(result)
				if (result.length === 1) {
					setSelectedLocation(result[0])
				}
			} else {
				setLocations([])
			}
		}
		catch (e) {
			console.log(e)
		}
	}
	
	function UserSelected() {
		var checkedIn: string = "";
		
		if (selectedUser && selectedUser.signed_in) {
			checkedIn = " is currently clocked in."
		}

		if (selectedUser && !selectedUser.signed_in) {
			checkedIn = " is currently clocked out."
		}
		
		if (selectedUser) {
			return (
				<div style={{color: 'red', alignContent:'center', justifyContent:'center'}}>
					{selectedUser.first_name} {selectedUser.middle_name} {selectedUser.last_name} {checkedIn}
				</div>
			)
		} else {
			return (
				<div></div>
			)
		}
	};


	function clearUser() {
		if (userRef.current) {
			userRef.current.value = "";
		}
		if (selectRef && selectRef.current) {
			selectRef.current.setValue({value: 0, label:""}, "deselect-option")
		}
		setSelectedUser({ id: 0, first_name: "", middle_name: "", last_name: "", signed_in: false, photo: "", active: false, email: "", password: "", role: "" })
	};

	async function Submit() {
		interface Payload {
			user_id: number;
			event_time: Date | null;
			event: string;
			event_date: Date | null;
			unit: string;
			location: string;
			entry_method: string;
			entered_by: string;
		}
		var userId: number = 0;
		userId = selectedUser.id;

		var eventTime: Date | null = new Date((new Date().setHours(new Date().getHours() - (new Date().getTimezoneOffset() / 60))))
		console.log("Submitting with time: ", eventTime)
		if (timeRef.current) {
			console.log("timeRef.current.valueAsDate: ", timeRef.current.valueAsDate)
			eventTime = timeRef.current.valueAsDate;
		} else {
			console.log("timeRef.current is null")
		}
		console.log("eventTime: ", eventTime)
		var event: string = "";
		if (selectedUser && selectedUser.signed_in) {
			event = "sign_out";
		}
		if (selectedUser && !selectedUser.signed_in) {
			event = "sign_in";
		}
		var eventDate: Date | null = new Date();
		if (dateRef && dateRef.current) {
			eventDate = dateRef.current.valueAsDate;
		}
		var unit: string = "";
		if (unitRef && unitRef.current) {
			unit = unitRef.current.value;
		}

		var location: string = "";
		if (locationRef && locationRef.current) {
			location = locationRef.current.value;
		}

		var entry_method = "clock_entry";
		var entered_by = localStorage.getItem("userID")
		if (entered_by == null) {
			entered_by = ""
		}
		
		var payload: Payload = {
			user_id: userId,
			event_time: eventTime,
			event: event,
			event_date: eventDate,
			unit: unit,
			location: location,
			entry_method: entry_method,
			entered_by: entered_by
		};

        const resp = await fetch(process.env.REACT_APP_API+"/api/clock", {
			method: "POST",
			body: JSON.stringify(payload)
		});
		const msg = await resp.json()
		setRespMsg(msg.msg)
		if (unitRef && unitRef.current) {
			unitRef.current.value=""
		}
		if (locationRef && locationRef.current) {
			locationRef.current.value=""
		}
		if (timeRef && timeRef.current) {
			timeRef.current.value = new Date((new Date().setHours(new Date().getHours() - (new Date().getTimezoneOffset() / 60)))).toISOString().split("T")[1].substring(0, 5)
		}
	}




	const handleUnitsChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const id = event.target.value;
		const unit = units.find((unit) => unit.id === parseInt(id))
		if (unit) {
			setSelectedUnit(unit)
		}
	}
	
	const handleLocationChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const id = event.target.value;
		const location = locations.find((location) => location.id === parseInt(id))
		if (location) {
			setSelectedLocation(location)
		}
	}

	const FetchUsersByUnit = async (unitID: number) => {
		try {
			const response = await fetch(process.env.REACT_APP_API+"/api/usersByUnit?unitID="+unitID)
			const result = await response.json()
			if (result) {
				setUsers(result)
			}
		}
		catch (e) {
			console.log(e)
		}
	}
	

	const clearData = () => {
		setRespMsg("")
		if (unitRef && unitRef.current) {
			unitRef.current.value = ""
		}
		setSelectedUnit({id:0, unit:"", active: false})
		setSelectedLocation({id:0, short_name:"", long_name:""})

		if (locationRef && locationRef.current) {
			locationRef.current.value = ""
		}

 	}

	const getLocationByID = async (locationID: number) => {
		try {
			const response = await fetch(process.env.REACT_APP_API+"/api/locationByID?id="+locationID)
			const result = await response.json()


			if (result) {
				setLocations([result])
				setSelectedLocation(result)
			}
		}
		catch (e) {
			console.log(e)
		}
	}
	
	
	useEffect(() => {
		const defaultUnit = localStorage.getItem("defaultUnit")
		const defaultLocation = localStorage.getItem("defaultLocation")
		const authCookie = Cookies.get("resilire_auth")

		if (defaultUnit) {
			FetchUsersByUnit(parseInt(defaultUnit))
			getUnitByID(parseInt(defaultUnit))
			unitRef.current!.value = defaultUnit
			getLocationByID(parseInt(defaultLocation!))
		}  else if (authCookie && atob(authCookie) === "mobile") {
			const decodedCookie = atob(authCookie)
			if (decodedCookie === "mobile") {
				const FetchMobileUser = async () => {
					const userID = localStorage.getItem("userID")
					try {
						const response = await fetch(process.env.REACT_APP_API+"/api/mobileUser?userID="+userID)
						const result = await response.json()
						if (result) {
							setUsers([result])
						}
					} catch (e) {
						console.log(e)
					}
				}
				FetchMobileUser()
				getUnitsForUser(selectedUser.id)
				getLocationsForUser(selectedUser.id)
			}
		} else {
			FetchActiveUsers(setUsers);
			getUnitsForUser(selectedUser.id)
			getLocationsForUser(selectedUser.id)
		}

		setCurrentTime(new Date((new Date().setHours(new Date().getHours() - (new Date().getTimezoneOffset() / 60)))).toISOString().split("T")[1].substring(0, 5))
		const intervalId = setInterval(() => {
			setCurrentTime(new Date((new Date().setHours(new Date().getHours() - (new Date().getTimezoneOffset() / 60)))).toISOString().split("T")[1].substring(0,5))
			if (timeRef && timeRef.current) {
				timeRef.current.value = new Date((new Date().setHours(new Date().getHours() - (new Date().getTimezoneOffset() / 60)))).toISOString().split("T")[1].substring(0,5)
			}
		}, 15000);

		if (selectedUser) {
			
			if (selectedUser.signed_in) {
				const fetchLastUnit = async(id: number) => {
					const response = await fetch(process.env.REACT_APP_API+"/api/lastUnit?id="+id)
					const result = await response.json()
					if (unitRef && unitRef.current) {
						unitRef.current.value=result.id
					}
				}
				
				const fetchLastLocation = async(id: number) => {
					const response = await fetch(process.env.REACT_APP_API+"/api/lastLocation?id="+id)
					const result = await response.json()
					if (locationRef && locationRef.current) {
						locationRef.current.value=result.id
					}
				}
				fetchLastUnit(selectedUser.id)
				fetchLastLocation(selectedUser.id)
			}
		}

		return () => {
			clearInterval(intervalId);
		};

	}, [selectedUser, unitRef, locationRef, selectedUser.signed_in, setSelectedUser, setUsers])
	
	return (
		<section className="content">

			<div className="resilire">
				<UserSelect isVisible={isVisible} setIsVisible={setIsVisible} users={users} setUsers={setUsers} setSelectedUser={setSelectedUser} ref={userRef} selectRef={selectRef} onChange={clearData} />
				<label htmlFor="unit">Unit</label>
				<select id="unit" name="unit" value={selectedUnit.id} ref={unitRef} onChange={handleUnitsChange}>
					<option value=""></option>
					{
						units.map((unit) => (
							<option value={unit.id} key={unit.id}>{unit.unit}</option>
						))
					}
				</select>
				<label htmlFor="location">Location</label>
				<select id="location" name="location" value={selectedLocation.id} ref={locationRef} onChange={handleLocationChange}>
					<option value=""></option>
					{
						locations.map((location) => (
							<option value={location.id} key={location.id}>{location.short_name} - {location.long_name}</option>
						))
					}
				</select>

				<label htmlFor="time">Time</label>
				<input type="time" id="clock_time" name="clock_time" defaultValue={currentTime} ref={timeRef} />
				<label htmlFor="currentDate">Date</label>
				<input type="date" id="current_date" name="current_date" defaultValue={currentDate.substring(0, 10)} />
			</div>
			<div className="resilire">
				<button id="submit" onClick={() => { setIsVisible(false); Submit(); clearUser() }}>Submit</button>
			</div>

			{isVisible &&
				(
					<div style={{alignContent:'center', justifyContent:'center'}}>
						<UserSelected />
						<PhotoDisplay photoName={selectedUser.photo} />
					</div>
				)
			}

			{respMsg && (
				<div style={{color:'red'}}>
					{respMsg}
				</div>
			)}
		</section>
	)
};

export default Clock;
